import { Subscription } from 'types';

import { BASE_SEATS_PER_PLAN } from '@/constants/common';

export const isTeamsPlan = (subscription: Subscription) => {
  return (
    subscription?.prices?.products?.name === 'Teams' ||
    subscription?.prices?.products?.name === 'Teams 6 seats' ||
    subscription?.prices?.products?.name === 'Teams 5 seats' ||
    subscription?.prices?.products?.name === 'Teams 10 seats' ||
    subscription?.prices?.products?.name === 'Teams 20 seats' ||
    subscription?.prices?.products?.name === 'Teams 30 seats' ||
    subscription?.prices?.products?.name === 'Teams 40 seats' ||
    subscription?.prices?.products?.name === 'Teams 200' ||
    subscription?.prices?.products?.name === 'Teams 300' ||
    (subscription?.additional_seats != null &&
      subscription.additional_seats > 0)
  );
};

// Seats granted by hand (profiles.bonus_seats). Reads 0 when the column is
// missing, empty or not a positive whole number.
export const bonusSeatsOf = (
  profile: { bonus_seats?: number | null } | null | undefined,
) => {
  const value = Number(profile?.bonus_seats);
  return Number.isFinite(value) && value > 0 ? Math.floor(value) : 0;
};

// Every seat a team owner has: the plan's own seats (1 for individual plans),
// seats bought through Stripe, and seats granted by hand.
export const teamSeatTotal = ({
  planName,
  additionalSeats,
  bonusSeats,
}: {
  planName: string | null | undefined;
  additionalSeats?: number | null;
  bonusSeats?: number | null;
}) =>
  (planName ? BASE_SEATS_PER_PLAN[planName] || 1 : 1) +
  Math.max(0, additionalSeats || 0) +
  Math.max(0, bonusSeats || 0);
